import React from 'react';
import { linkLabelFromUrl, toSafeHttpHref } from '../urlUtils';

export default function LinkButton({ url, label }) {
  const safeHref = toSafeHttpHref(url);
  if (!safeHref) return null;
  const text = label || linkLabelFromUrl(url);

  return (
    <a
      href={safeHref}
      target="_blank"
      rel="noopener noreferrer"
      className="message-link-button"
      onClick={(e) => e.stopPropagation()}
    >
      <span className="message-link-button-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
          <polyline points="15 3 21 3 21 9" />
          <line x1="10" y1="14" x2="21" y2="3" />
        </svg>
      </span>
      <span className="message-link-button-text">{text}</span>
    </a>
  );
}
